<div
    class="message-bubble"
    [ngClass]="{fromMe: fromMe, fromOther: !fromMe}"
>
    <div
        *ngIf="!fromMe"
        class="avatar-wrapper"
    >
        <ng-container *ngIf="userData else spinner">
            <img  class="profilePic"
                [src]="getAvatarUrl(showAvatar$ | async)"
                (error)="onImageError($event, 'x-small', 'avatar')" 
            />
            <img
                *ngIf="userData.useNftAsAvatar"
                class="ether-logo"
                src="assets/img/eth_logo.svg"
            />
        </ng-container>
    </div>
    <div class="msg-wrap">
        <div *ngIf="userData; else nameSkeleton" class="name">
            {{ userData.displayName }}
        </div>
        <div class="message">
            {{message.text}}
            <div class="arrow-up"></div>
        </div>
        <p class="timestamp">
            {{ message.dateCreated.toDate() | amCalendar:{
            lastDay : '[Yesterday]',
            slastDay : '[Yesterday]',
            sameDay : 'LT',
            lastWeek : 'dddd',
            sameElse : 'LL'} }}
        </p>
    </div>
</div>

<ng-template #spinner>
    <ion-spinner name="bubbles"></ion-spinner>
</ng-template>

<ng-template #nameSkeleton>
    <ion-skeleton-text class="name-skeleton" animated></ion-skeleton-text>
</ng-template>
